import React, { Fragment } from "react";

import Galka from "~/assets/img/svg/galka.png";
import Krest from "~/assets/img/svg/krest.png";
import Krug from "~/assets/img/svg/krug.png";
import AccoutingPeriodTableRow from "~/components/Table/TableRow/AccoutingPeriodTableRow";
import DefaultTableRow from "~/components/Table/TableRow/DefaultTableRow";
import EditorIndicatorsTableRow from "~/components/Table/TableRow/EditorIndicatorsTableRow";
import EditorVersionsTableRow from "~/components/Table/TableRow/EditorTableRow";
import EmployeeTableRow from "~/components/Table/TableRow/EmployeeTableRow";
import GRTableRow from "~/components/Table/TableRow/GRTableRow";
import PKDTableRow from "~/components/Table/TableRow/PKDTableRow";
import ProjectDocumentTableRow from "~/components/Table/TableRow/ProjectDocumentTableRow";
import QTableRow from "~/components/Table/TableRow/QTableRow";
import SRRTableRow from "~/components/Table/TableRow/SRRTableRow";
import StaffTableRow from "~/components/Table/TableRow/StaffTableRow";
import SubdivisionTableRow from "~/components/Table/TableRow/SubdivisionTableRow";
import ViolationsTableRow from "~/components/Table/TableRow/ViolationsTableRow";
import ZDTableRow from "~/components/Table/TableRow/ZDTableRow";
import ZDUsouoTableRow from "~/components/Table/TableRow/ZDUsouoTableRow";
import { getRowTypeFromTableIndex } from "~/components/Table/TableRow/ZDTableRow/options";
import { getFormatDate } from "~/libs/getFormatDate";
import { NUMBER_OPTIONS } from "~/pages/ZD/TableReducerZD/options";

interface IProps {
  options: string[];
  optionChildren: string[];
  nameChildren?: string[];
  arrTableRowsPeriod?: string[];
  arrObjects?: [];
  type: string;
  role?: string;
  groupNameSrr?: string;
  control?;
  refetch?;
  selectParent?;
  onSumbitDublicate?;
  errors?;
  handleSubmit?;
  setValue?;
  onSubmit?;
  btnEdit?: boolean;
  loading?: boolean;
  btnView?: boolean;
  btnDel?: boolean;
  btnDownload?: boolean;
  btnCustom?: (props: any) => JSX.Element;
  btnVersion?: boolean;
  btnIndicators?: boolean;
  btnEditStatus?: boolean;
  searchTextForSelect_ONLY_SRR?: string;
  styleRow?: boolean;
  withChbx?: boolean;
  onSet?: () => void;
  item;
  rowCanBeClicked?: ((item: any) => boolean) | boolean;
  rowClickHandler?: (item: any) => void;
  rowValuesDecorator?: (
    value: any,
    optionName: string,
    dataObject?: any,
  ) => any;
}

const TableRow: React.FC<IProps> = ({
  options = [],
  optionChildren = [],
  arrObjects = [],
  nameChildren = [],
  arrTableRowsPeriod = [],
  item = {},
  control,
  selectParent,
  onSumbitDublicate,
  groupNameSrr,
  errors,
  handleSubmit,
  setValue,
  onSubmit,
  refetch,
  btnEdit = false,
  btnView = false,
  btnDel = false,
  btnDownload = false,
  btnCustom,
  loading = false,
  btnVersion = false,
  btnEditStatus = false,
  btnIndicators = false,
  styleRow = false,
  withChbx = false,
  type,
  rowClickHandler,
  rowCanBeClicked,
  rowValuesDecorator,
  searchTextForSelect_ONLY_SRR,
}) => {
  const language = localStorage.getItem("language");
  const isEn = language === "en";
  let row = {};
  switch (type) {
    case "violationsTable":
      row = (
        <ViolationsTableRow
          {...{
            options,
            item,
            btnVersion,
          }}
        />
      );
      break;
    case "pkd":
      row = (
        <PKDTableRow
          options={options}
          control={control}
          btnDel={btnDel}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          item={item}
        />
      );
      break;
    case "staff":
      row = <StaffTableRow withChbx={withChbx} options={options} item={item} />;
      break;
    case "employeeTraining":
      row = (
        <EmployeeTableRow
          options={options}
          item={item}
          rowValuesDecorator={rowValuesDecorator}
        />
      );
      break;
    case "editor.versions":
      row = (
        <EditorVersionsTableRow
          type={type}
          btnEdit={btnEdit}
          btnView={btnView}
          btnDel={btnDel}
          btnIndicators={btnIndicators}
          options={options}
          item={item}
        />
      );
      break;
    case "editorQ":
    case "editorGR":
    case "editorStaff":
    case "editorZD":
      row = (
        <EditorIndicatorsTableRow
          type={type}
          btnEdit={btnEdit}
          btnView={btnView}
          setValue={setValue}
          selectParent={selectParent}
          btnDel={btnDel}
          options={options}
          optionChildren={optionChildren}
          item={item}
        />
      );
      break;
    case "editorSubdivision":
      row = (
        <SubdivisionTableRow
          options={options}
          type={type}
          item={item}
          btnEdit={btnEdit}
          btnView={btnView}
          btnDel={btnDel}
          btnVersion={btnVersion}
          nameChildren={nameChildren}
        />
      );
      break;
    case "globalRating":
      row = (
        <GRTableRow
          options={options}
          optionChildren={optionChildren}
          styleRow={styleRow}
          item={item}
        />
      );
      break;
    case "q":
      row = (
        <QTableRow
          options={options}
          optionChildren={optionChildren}
          item={item}
        />
      );
      break;
    case "srr":
      row = (
        <SRRTableRow
          type={type}
          groupNameSrr={groupNameSrr}
          arrTableRowsPeriod={arrTableRowsPeriod}
          rowValuesDecorator={rowValuesDecorator}
          options={options}
          item={item}
          searchTextForSelect_ONLY_SRR={searchTextForSelect_ONLY_SRR}
        />
      );
      break;
    case "Staff":
      row = (
        <StaffTableRow
          options={options}
          //optionChildren={optionChildren}
          item={item}
        />
      );
      break;
    case "accounting":
      row = (
        <AccoutingPeriodTableRow
          btnEdit={btnEdit}
          options={options}
          type={type}
          item={item}
        />
      );
      break;
    case "usouo":
      row = (
        <ZDUsouoTableRow
          options={options}
          //optionChildren={optionChildren}
          item={item}
          type={type}
        />
      );
      break;
    case "project":
      row = (
        <ProjectDocumentTableRow
          options={options}
          //optionChildren={optionChildren}
          item={item}
        />
      );
      break;
    case "zd":
    case "planReport":
      row = (
        <ZDTableRow
          isGroupExternal={!!item.isList}
          options={options}
          control={control}
          loading={loading}
          errors={errors}
          refetch={refetch}
          selectParent={selectParent}
          item={item}
          arrObjects={arrObjects}
          onSubmit={onSubmit}
          onSumbitDublicate={onSumbitDublicate}
          setValue={setValue}
          handleSubmit={handleSubmit}
          type={type}
        />
      );
      break;
    default:
      row = (
        <DefaultTableRow
          options={options}
          type={type}
          item={item}
          btnDownload={btnDownload}
          btnCustom={btnCustom}
          btnEdit={btnEdit}
          btnView={btnView}
          btnDel={btnDel}
          btnVersion={btnVersion}
          btnEditStatus={btnEditStatus}
          nameChildren={nameChildren}
          rowClickHandler={rowClickHandler}
          rowCanBeClicked={rowCanBeClicked}
          rowValuesDecorator={rowValuesDecorator}
        />
      );
      break;
  }

  const elementList =
    ["zd", "planReport"].includes(type) &&
    item.isList &&
    item.list.reduce((accFirst, el) => {
      accFirst = accFirst || [];

      accFirst = [
        ...accFirst,
        Object.keys(el).reduce((acc, key) => {
          if (NUMBER_OPTIONS.includes(key)) {
            const defaultGood = {
              value: 1,
              label: "provided",
              icon: Galka,
            };
            const defaultBad = {
              value: 0,
              label: "not_provided",
              icon: Krest,
            };
            const defaultNone = {
              value: "",
              label: "нету",
              icon: Krug,
            };

            if (key === "Compliance") {
              acc[key] =
                el[key] === null || el[key] === undefined
                  ? defaultNone
                  : el[key]
                    ? defaultGood
                    : defaultBad;
            } else {
              acc[key] =
                typeof el[key] === "number"
                  ? el[key] === 0
                    ? defaultBad
                    : defaultGood
                  : defaultNone;
            }
            return acc;
          }

          // for date view
          if (key === "ActualFrom") {
            acc[key] = getFormatDate(new Date(el[key]), true);
            return acc;
          }
          // for Name En
          if (key === "Name") {
            acc[key] = isEn ? el["NameEn"] : el[key];
            return acc;
          }
          acc[key] = el[key];
          return acc;
        }, {}),
      ];

      return accFirst;
    }, []);

  // Передаём tableIndex родителя подстрокам, чтобы они знали свой тип
  const parentTableIndex = item.tableIndex;

  return (
    <>
      {!item.isList ? (
        row
      ) : (
        <>
          {row}

          {["zd", "planReport"].includes(type) &&
            elementList.map((el, id) => {
              return (
                <Fragment key={id}>
                  <ZDTableRow
                    options={options}
                    control={control}
                    loading={loading}
                    errors={errors}
                    item={{
                      ...el,
                      tableIndex: parentTableIndex,
                      rowType:
                        item.rowType ??
                        getRowTypeFromTableIndex(parentTableIndex),
                    }}
                    arrObjects={arrObjects}
                    onSubmit={onSubmit}
                    onSumbitDublicate={onSumbitDublicate}
                    setValue={setValue}
                    handleSubmit={handleSubmit}
                    parentObject={item}
                    type={type}
                  />
                </Fragment>
              );
            })}
        </>
      )}
    </>
  );
};
export default TableRow;
